/**
 * 商户结算统计
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="商户类型:">
        <el-select
          size="small"
          v-model="formInline.agentType"
          placeholder="全部"
        >
          <el-option
            v-for="(val, index) in merchantTypeList"
            :label="val.label"
            :value="val.value"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商户:">
        <el-select
          size="small"
          v-model="formInline.merchantName"
          filterable
          allow-create
          default-first-option
          placeholder="请选择或输入商户名称"
          @blur="selectMerchantNameBlur"
        >
          <el-option
            v-for="(val, index) in merchantList"
            :label="val"
            :value="val"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="服务商:">
        <el-select
          size="small"
          v-model="formInline.disCompanyName"
          filterable
          allow-create
          default-first-option
          placeholder="请选择或输入服务商名称"
          @blur="selectDisCompanyBlur"
        >
          <el-option
            v-for="(val, index) in disCompanyList"
            :label="val.label"
            :value="val.label"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间范围: ">
        <el-date-picker
          size="small"
          v-model="formInline.date"
          type="daterange"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">搜索</el-button>
        <el-button size="small" @click="reset">清空</el-button>
      </el-form-item>
    </el-form>

    <div style="margin-bottom: 10px">
      <el-button type="primary" size="small" @click="exportdata"
        >导出数据</el-button
      >
      <el-button type="primary" size="small" @click="onSearchMerchants"
        >检索商户</el-button
      >
    </div>

    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
      <el-table-column
        fixed
        prop="merchantName"
        label="商户名称"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="agentType" label="类型" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ getAgentTypeLabel(scope.row.merchantType) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="phoneSalesName" label="电销" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="faceSalesName" label="面销" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="industry" label="所属行业" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="managementFeeRate"
        label="管理费率"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ formatRate(scope.row.managementFeeRate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="distributeCompanyName"
        label="下发公司"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>

    <el-dialog title="检索商户" :visible.sync="dialogTableVisible">
      <el-table :data="dialogTableData" size="small">
        <el-table-column
          property="companyName"
          label="商户名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          property="status"
          label="签约状态"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span
              :style="{
                color: scope.row.status === '已签约' ? '#67C23A' : '#F56C6C',
              }"
            >
              {{ scope.row.status }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSalesMerchants,
  getSalesMerchantName,
  getDisCompanyNames,
  searchMerchants,
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      infos: {
        totalServiceFee: 0,
        totalCommission: 0,
      },
      activities: [],
      merchantList: [],
      disCompanyList: [],
      merchantTypeList: [
        {
          label: "普通商户",
          value: 1,
        },
        {
          label: "代理商户",
          value: 2,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载

      dialogTableData: [],
      dialogTableVisible: false,

      // rules表单验证
      rules: {},
      formInline: {
        page: 1,
        pageSize: 10,
        merchantName: "",
        disCompanyName: "",
        startDate: "",
        endDate: "",
        agentType: "",
        date: [],
      },

      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */
  computed: {},
  /**
   * 创建完毕
   */
  created() {
    getSalesMerchantName({
      page: 1,
      pageSize: 9999,
    })
      .then((res) => {
        if (res.msg == "success") {
          this.merchantList = res.data.items;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      })
      .catch((err) => {});
    // 服务商
    getDisCompanyNames({
      page: 1,
      pageSize: 9999,
      type: 2,
    })
      .then((res) => {
        if (res.msg == "success") {
          this.disCompanyList = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      })
      .catch((err) => {});
    this.getdata(this.formInline);
  },

  watch: {
    "formInline.agentType": function (newVal) {
      let params = {
        agentType: newVal,
      };

      getSalesMerchantName(params)
        .then((res) => {
          if (res.msg == "success") {
            this.merchantList = res.data.items;
            this.formInline.merchantName = "";
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {});
    },
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    statusCellStyle({ row }) {
      console.log(row.status);
      return row.status === "已签约"
        ? "color: #67C23A;" // 绿色
        : "color: #F56C6C;"; // 红色
    },
    onSearchMerchants() {
      this.$prompt("请输入检索商户", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[\s\S]{1,100}$/,
        inputErrorMessage: "请输入有效的商户名称",
      })
        .then(({ value }) => {
          const trimmedValue = value.trim();

          searchMerchants({
            merchantName: trimmedValue,
          }).then((res) => {
            if (res.msg == "success") {
              this.dialogTableVisible = true;
              if (res.data && res.data.length > 0) {
                // 后端有数据，渲染数据并设置状态为"已签约"
                this.dialogTableData = res.data.map((item) => ({
                  companyName: item.companyName,
                  status: "已签约", // 统一设置状态为已签约
                }));
              } else {
                // 数组为空
                this.dialogTableData = [
                  {
                    companyName: trimmedValue,
                    status: "未签约",
                  },
                ];
              }
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        merchantName: "",
        disCompanyName: "",
        agentType: "",
        date: [],
      };
      this.getdata(this.formInline);
    },
    // 获取公司列表
    getdata(formInline) {
      let params = {
        page: formInline.page,
        pageSize: formInline.pageSize,
        disCompanyName: formInline.disCompanyName,
        merchantName: formInline.merchantName,
        startDate: formInline.startDate,
        endDate: formInline.endDate,
        agentType: formInline.agentType,
      };
      getSalesMerchants(params)
        .then((res) => {
          if (res.msg == "success") {
            this.listData = res.data.items;
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {});
    },
    exportdata() {
      // 默认导出99999
      let params = {
        page: 1,
        pageSize: 99999,
        merchantName: this.formInline.merchantName,
        disCompanyName: this.formInline.disCompanyName,
        startDate: this.formInline.startDate,
        endDate: this.formInline.endDate,
        agentType: this.formInline.agentType,
        export: 1,
      };
      getSalesMerchants(params)
        .then((res) => {
          if (res.msg == "success") {
            if (res.data && res.data.downloadUrl) {
              window.open(res.data.downloadUrl);
            } else {
              this.$message({
                type: "error",
                message: "导出链接为空，请联系管理员",
              });
            }
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {});
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      if (this.formInline.date && this.formInline.date.length === 2) {
        this.formInline.startDate = this.formInline.date[0] || "";
        this.formInline.endDate = this.formInline.date[1] || "";
      } else {
        this.formInline.startDate = "";
        this.formInline.endDate = "";
      }
      this.getdata(this.formInline);
    },
    getAgentTypeLabel(agentType) {
      const type = this.merchantTypeList.find(
        (item) => item.value === agentType
      );
      return type ? type.label : "未知";
    },

    formatRate(rate) {
      if (rate != null && rate !== undefined) {
        return `${(parseFloat(rate) * 100).toFixed(2)}%`;
      }
      return ""; // 或者根据你的需求返回其他默认值
    },
    selectBlur(e) {
      this.formInline.merchantName = e.target.value;
    },
    formatNumber(num) {
      return num ? num.toFixed(2) : "0.00";
    },
    selectMerchantNameBlur(e) {
      this.formInline.merchantName = e.target.value;
    },
    selectDisCompanyBlur(e) {
      this.formInline.disCompanyName = e.target.value;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.userRole {
  width: 100%;
}
</style>

 


// WEBPACK FOOTER //
// src/views/sales/merchantList.vue